import { createApiClient } from "./client";

const client = createApiClient();

export const branding = {
    getBranding: ({ domain }: { domain: string }) =>
        client
            .get(
                `/clients/${domain}`
            )
            .then(({ data }) => data),
};
